import { useGetUser } from "@/hooks/requests/user/use-get-user";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { memo, useRef, useState } from "react";
import { ProfilePageContainer } from "../../components/containers/profile-page-container";
import { ProfileGoalInfoCard } from "../../components/profile-goal-info-card";
import { ProfileImage } from "../../components/profile-image";
import { ProfileNutritionCard } from "../../components/profile-nutrition-card";
import { ProfileSettingsModal } from "../../components/profile-settings-modal";
import { ProfileStatusCard } from "../../components/profile-status-card";

const ProfilePage = memo(function ProfilePage() {
  const { user } = useGetUser();
  const pageRef = useRef<HTMLElement>(null);
  const [isSettingsModalOpen, setIsSettingsModalOpen] = useState(false);

  const personalInfo = user?.personalInfo;
  const firstName = personalInfo?.firstName ?? "";

  return (
    <ProfilePageContainer
      pageRef={pageRef}
      className="gap-9 px-4 pt-2"
      backgroundColor="var(--color-screen-gray)"
      onSettingButtonClick={() => setIsSettingsModalOpen(true)}
    >
      <div className="flex flex-col items-center gap-6 px-4">
        <ProfileImage />
        <h1
          className={cn(
            textVariants.serif,
            "text-[32px] leading-[45px] font-semibold tracking-[-1px] text-[#1d1232]",
          )}
        >
          Hi, {firstName}!
        </h1>
      </div>

      <ProfileStatusCard />

      <ProfileGoalInfoCard />

      <ProfileNutritionCard />

      <ProfileSettingsModal
        pageRef={pageRef}
        isOpen={isSettingsModalOpen}
        onDismiss={() => setIsSettingsModalOpen(false)}
      />
    </ProfilePageContainer>
  );
});

export default ProfilePage;
